import styled from "@emotion/styled";

export const TradeAndWrapWrapper = styled.div<{ isMobile: boolean }>`
  max-width: 473px;
  width: 100%;
  height: fit-content;
  margin: ${props => (props.isMobile ? 16 : 36)}px auto;
  color: white;
  background: ${props => props.theme.surface.main.primary.default};
  padding: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  outline: 0;
  font-family: "Work Sans";
`;
